// FrontEnd/src/components/StatusBadge.jsx
export default function StatusBadge({ status }) {
  const map = {
    created: "secondary",
    pending: "warning",
    paid: "success",
    refunded: "info",
    failed: "danger",
    expired: "dark",
    fulfilled: "primary",
    cancelled: "danger",
  };
  const cls = map[String(status || "").toLowerCase()] || "secondary";
  return <span className={`badge text-bg-${cls}`}>{status}</span>;
}
